<template>
  <div
    class="box"
    @keydown="handleKeyDown"
    @contextmenu.prevent
    ref="fullscreenContainer"

  >
<!--    @click="enterFullscreen"-->
    <div id="myButton" @click="enterFullscreen" v-show="false"></div>
    <!-- 第一行 试卷名称 -->
    <div class="top-box">
      <div class="box-head-one">{{ examination.testName }}</div>
      <div class="box-head-two">
        <!-- 考生姓名 -->
        <div class="box-head-two-name">考生姓名：{{ this.userName }}</div>
        <!-- 准考证号 -->
        <!-- <div class="box-head-two-name">
          准考证号：{{ this.examRegistrationNumber }}
        </div> -->
        <div class="box-head-two-name">身份证号：{{ this.identityCard }}</div>
      </div>
    </div>
    <!-- 第二行 考生照片 考生试题顺序 考生试题 字体加减 -->
    <div class="center-box">
      <div class="options-box">
        <!-- 一个小图片 -->
        <!-- <div class="slide">
          <img src="../../assets/newImg/text_arrow.png" alt="" />
        </div> -->
        <!-- 左侧题目列表 -->
        <div v-if="radioSubjectType != 0">
          <div class="title">单项选择题</div>
          <!-- <div class="score-particulars">（本大题共120小题，每小题0.5分，共60分；在每小题的四个备选答案中，选出一个正确答案。错选、多选或未选均无分。）</div> -->
          <div class="topic-item">
            <div
              :class="{
                active: item.isOk || `radio-${index}` === currentActive
              }"
              v-for="(item, index) in radio"
              :key="`radio-${index}`"
              @click="handle(item, `radio-${index}`)"
            >
              {{ index + 1 }}
            </div>
          </div>
        </div>
        <div v-if="checkSubjectType != 0">
          <div class="title">多项选择题</div>
          <!-- <div class="score-particulars"></div> -->
          <div class="topic-item">
            <div
              :class="{
                active: item.isOk || `check-${index}` === currentActive
              }"
              v-for="(item, index) in check"
              :key="`check-${index}`"
              @click="handle(item, `check-${index}`)"
            >
              {{ index + 1 }}
            </div>
          </div>
        </div>
        <div v-if="istrueSubjectType != 0">
          <div class="title">判断题</div>
          <div class="topic-item">
            <div
              :class="{
                active: item.isOk || `istrue-${index}` === currentActive
              }"
              v-for="(item, index) in istrue"
              :key="`istrue-${index}`"
              @click="handle(item, `istrue-${index}`)"
            >
              {{ index + 1 }}
            </div>
          </div>
        </div>
        <div v-if="textareaSubjectType != 0">
          <div class="title">主观题</div>
          <div class="topic-item">
            <div
              :class="{
                active: item.isOk || `textarea-${index}` === currentActive
              }"
              v-for="(item, index) in textarea"
              :key="`textarea-${index}`"
              @click="handle(item, `textarea-${index}`)"
            >
              {{ index + 1 }}
            </div>
          </div>
        </div>
        <div v-if="choiceQuestionsSubjectType != 0">
          <div class="title">不定项选择题</div>
          <div class="topic-item">
            <div
              :class="{
                active:
                  item.isOk || `choiceQuestions-${index}` === currentActive
              }"
              v-for="(item, index) in choiceQuestions"
              :key="`choiceQuestions-${index}`"
              @click="handle(item, `choiceQuestions-${index}`)"
            >
              {{ index + 1 }}
            </div>
          </div>
        </div>
        <div v-if="scoreDistributeSubjectType != 0">
          <div class="title">分数分配题</div>
          <div class="topic-item">
            <div
              :class="{
                active:
                  item.isOk ||
                  `scoreDistributeQuestions-${index}` === currentActive
              }"
              v-for="(item, index) in scoreDistributeQuestions"
              :key="`scoreDistributeQuestions-${index}`"
              @click="handle(item, `scoreDistributeQuestions-${index}`)"
            >
              {{ index + 1 }}
            </div>
          </div>
        </div>
        <!-- <div v-if="rankingQuestionType != 0">
          <div class="title">排序题</div>
          <div class="topic-item">
            <div
              :class="{
                active: item.isOk || `rankingQuestion-${index}` === currentActive,
              }"
              v-for="(item, index) in rankingQuestion"
              :key="`rankingQuestion-${index}`"
              @click="handle(item, `rankingQuestion-${index}`)"
            >
              {{ index + 1 }}
            </div>
          </div>
        </div> -->
      </div>
      <!-- 中间题目详情 -->
      <div class="topic-box">
        <!-- 单选 -->
        <template v-for="(item, index) in radio">
          <topic-radio
            ref="paper"
            v-if="currentActive === `radio-${index}`"
            :key="`radio-content-${index}`"
            :RadioNum="index + 1"
            :RadioContent="item.subjectName"
            :redioList="JSON.parse(item.optionConf)"
            :data-id="item.subjectId"
            :currentAnswer="item.currentAnswer"
            @change="handleChange"
          ></topic-radio>
        </template>
        <!-- 多选 -->
        <template v-for="(item, index) in check">
          <topic-check
            ref="paper"
            v-if="currentActive === `check-${index}`"
            :key="`check-content-${index}`"
            :CheckNum="index + 1"
            :CheckContent="item.subjectName"
            :CheckList="JSON.parse(item.optionConf)"
            :data-id="item.subjectId"
            :currentAnswer="item.currentAnswer"
            @change="handleChange"
          ></topic-check>
        </template>
        <!-- 判断 -->
        <template v-for="(item, index) in istrue">
          <topic-true
            ref="paper"
            v-if="currentActive === `istrue-${index}`"
            :key="`istrue-${index}`"
            :TrueNum="index + 1"
            :TrueContent="item.subjectName"
            :TrueList="JSON.parse(item.optionConf)"
            :data-id="item.subjectId"
            :currentAnswer="item.currentAnswer"
            @change="handleChange"
          ></topic-true>
        </template>
        <!-- 主观题 -->
        <template v-for="(item, index) in textarea">
          <topic-textarea
            ref="paper"
            v-if="currentActive === `textarea-${index}`"
            :key="`textarea-${index}`"
            :TextareaNum="index + 1"
            :TextareaContent="item.subjectName"
            :TextareaList="JSON.parse(item.optionConf)"
            :data-id="item.subjectId"
            :currentAnswer="item.currentAnswer"
            @change="handleChange"
          ></topic-textarea>
        </template>
        <!-- 不定项选择题 -->
        <template v-for="(item, index) in choiceQuestions">
          <topic-choiceQuestions
            ref="paper"
            v-if="currentActive === `choiceQuestions-${index}`"
            :key="`choiceQuestions-${index}`"
            :choiceQuestionsNum="index + 1"
            :choiceQuestionsContent="item.subjectName"
            :ChoiceQuestionsList="item.indefiniteSubjectsList"
            :data-id="item.subjectId"
            :currentAnswer="item.currentAnswer"
            @change="handleChoiceChange"
          ></topic-choiceQuestions>
        </template>
        <!-- 分数分配题 -->
        <template v-for="(item, index) in scoreDistributeQuestions">
          <topic-ScoreDistributeQuestions
            :ref="'scoreDistr' + item.subjectId"
            v-if="currentActive === `scoreDistributeQuestions-${index}`"
            :key="`scoreDistributeQuestions-${index}`"
            :scoreDistributeNum="index + 1"
            :scoreDistributesContent="item.subjectName"
            :ScoreDistributeQuestionsList="item.scoreDistributeSubjectList"
            :data-id="item.subjectId"
            :currentAnswer="item.currentAnswer"
            @change="handleScoreDistributeChange"
          ></topic-ScoreDistributeQuestions>
        </template>
        <!-- 排序题 -->
        <!-- <template v-for="(item, index) in rankingQuestion">
          <topic-rankingQuestion
            ref="paper"
            v-if="currentActive === `rankingQuestion-${index}`"
            :key="`rankingQuestion-${index}`"
            :SortNum="index + 1"
            :TextareaSort="item.subjectName"
            :rankingQuestionList="JSON.parse(item.optionConf)"
            :data-id="item.subjectId"
            :currentAnswer="item.currentAnswer"
            @change="handleChange"
          ></topic-rankingQuestion>
        </template> -->
      </div>
      <div class="topic-right">
        <!-- 考生照片 -->
        <div class="user-img">
          <img :src="this.photograph" width="130px" height="160px" />
        </div>
        <!-- 剩余时间 -->
        <div class="surplus-time">
          <div class="surplus-time-top">剩余时间</div>
          <div class="surplus-time-color">
            {{ pad(hours) }}:{{ pad(remainingMinutes) }}:{{ pad(seconds) }}
          </div>
          <div class="surplus-time-line"></div>
          <!-- 进度条 -->
          <div class="progress-box">
            <div class="surplus-time-top">答题进度</div>
            <div class="bar-info">
              {{ isAnswer }} / {{ subjectList.length }}
            </div>
            <div class="bar"></div>
            <div
              class="slider"
              :style="{ width: progressPercentage + '%' }"
            ></div>
          </div>
          <div class="surplus-time-line"></div>
          <div class="topic-padding">
            <div class="topic-up" @click="backTopic">上一题</div>
            <div class="topic-below" @click="nextTopic">下一题</div>
          </div>
        </div>
        <div class="submit-buuton">
          <el-button type="primary" @click="submitText">提交试卷</el-button>
        </div>
        <!-- <div class="logo-text-ui">测试屏幕大小文字</div> -->
      </div>
    </div>
    <!-- 自定义模态框 -->
    <div v-if="isModalVisible" class="custom-modal">
      <div class="modal-content">
        <!-- <h3>重要提示</h3> -->
        <div class="modal-header" v-if="poupConfirmShow">{{ countDown }}</div>
        <div class="modal-body">
          <div class="modal-title">
            {{ poupContent }}
          </div>
        </div>
        <div class="modal-footer" v-if="poupConfirmShow">
          <button
            type="button"
            class="btn btn-gray"
            data-dismiss="modal"
            @click="poupConfirm"
          >
            知道了
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TopicRadio from "@/components/topicRadio.vue";
import TopicCheck from "@/components/topicCheck.vue";
import TopicTrue from "@/components/topicTrue.vue";
import TopicTextarea from "@/components/topicTextarea.vue";
import TopicChoiceQuestions from "@/components/topicChoiceQuestions.vue";
import TopicScoreDistributeQuestions from "@/components/topicScoreDistributeQuestions.vue";
import TopicRankingQuestion from "@/components/TopicRankingQuestion.vue";
import screenfull from "screenfull";

export default {
  components: {
    TopicRadio,
    TopicCheck,
    TopicTrue,
    TopicTextarea,
    TopicChoiceQuestions,
    TopicScoreDistributeQuestions,
    TopicRankingQuestion
  },
  data() {
    return {
      isFullscreen: false,
      examStarted: false,

      examId: "",
      examination: {},
      userName: "",
      examRegistrationNumber: "",
      identityCard: "",
      photograph: "",
      hours: 0,
      remainingMinutes: 0,
      seconds: 0,
      currentActive: `radio-0`, //已做未做
      redioList: [], // 单选
      CheckList: [], // 多选
      TrueList: [], // 判断
      TextareaList: [], // 主观
      ChoiceQuestionsList: [], // 不定项
      rankingQuestionList: [], // 排序
      RadioNum: 1, // 单选
      RadioContent: "", // 单选
      CheckNum: 1, // 多选
      CheckContent: "", // 多选
      TrueNum: 1, // 判断
      TrueContent: "", // 判断
      TextareaNum: 2, // 主观
      TextareaContent: "", // 主观
      choiceQuestionsNum: 1, // 不定项
      choiceQuestionsContent: "", // 不定项
      scoreDistributeNum: 1, // 分数分配题
      scoreDistributeContent: "", // 分数分配题
      SortNum: 2, // 排序
      TextareaSort: "", // 排序
      radio: [], // 单选题
      check: [], // 多选题
      istrue: [], // 判断题
      textarea: [], // 主观
      choiceQuestions: [], // 不定项选择题
      scoreDistributeQuestions: [], // 分数分配题题
      rankingQuestion: [], // 排序题
      radioSubjectType: 0, // 单选题个数
      checkSubjectType: 0, // 多选题个数
      istrueSubjectType: 0, // 判断题个数
      textareaSubjectType: 0, // 主观题个数
      choiceQuestionsSubjectType: 0, // 不定项选择题个数
      scoreDistributeSubjectType: 0, // 分数分配题个数
      rankingQuestionType: 0, // 排序题
      intervalId: null,
      subjectList: [], // 题目个数
      isAnswer: 0,
      illegalOperateCount: 0,
      illegalOperateTimer: null,
      isPageVisible: false,
      isModalVisible: false,
      poupContent: "",
      countDown: 20,
      poupConfirmShow: true
    };
  },
  computed: {
    // 进度条
    progressPercentage() {
      return (this.isAnswer / this.subjectList.length) * 100;
    }
  },
  created() {
    if (this.$route.query.examId) {
      this.examId = this.$route.query.examId;
      this.getExaminationDetail();
      this.getStartExamination();
    }

    this.selectUser();
  },
  // beforeDestroy() {
  //   this.stopCountdown();
  // },
  mounted() {
    let _this = this;
    document.addEventListener("keydown", this.handleKeyDown);
    // this.initFullscreenListeners();
    var browerWidth = window.innerWidth; //浏览器可视宽度
    var baseWidth = 1920; //设计稿宽度
    var zoomValue = browerWidth / baseWidth; //缩放比例计算
    // document.getElementById("mainContainer").style.transform =
    //   "scale(" + zoomValue + "," + zoomValue + ")"; //mainContainer为主容器id
    // window.onresize = function () {
    //   //窗口尺寸变化时，重新计算和缩放
    //   browerWidth = window.innerWidth;
    //   zoomValue = browerWidth / baseWidth;
    //   document.getElementById("mainContainer").style.transform =
    //     "scale(" + zoomValue + "," + zoomValue + ")";
    // };
    window.onresize = () => {
      if (!_this.checkFull()) {
        // 退出全屏后要执行的动作
        console.log("退出全屏");
        // _this.enterFullscreen();
      }
    };
  },
  beforeDestroy() {
    this.stopCountdown();
    if (this.illegalOperateTimer) {
      clearInterval(this.illegalOperateTimer);
    }

    this.removeFullscreenListeners();
  },

  methods: {
    checkFull() {
      //判断浏览器是否处于全屏状态 （需要考虑兼容问题）
      //火狐浏览器
      let isFull =
        document.mozFullScreen ||
        document.fullScreen ||
        //谷歌浏览器及Webkit内核浏览器
        document.webkitIsFullScreen ||
        document.webkitRequestFullScreen ||
        document.mozRequestFullScreen ||
        document.msFullscreenEnabled;
      if (isFull === undefined) {
        isFull = false;
      }
      return isFull;
    },
    // 禁止浏览器复制粘贴 在div中是默认不可编辑的区域 把div设置成可编辑区域 就可以 contenteditable
    handleKeyDown(event) {
      if (
        (event.ctrlKey || event.metaKey) &&
        (event.key === "c" || event.key === "v")
      ) {
        event.preventDefault(); // 阻止默认的复制或粘贴行为
      }
      if (event.key === "Escape" || event.key === "F5") {
        event.preventDefault();
        // this.enterFullscreen()
        // document.getElementById("myButton").click();
      }
    },

    // 初始化全屏事件监听
    initFullscreenListeners() {
      document.addEventListener(
        "fullscreenchange",
        this.handleFullscreenChange
      );
      document.addEventListener(
        "webkitfullscreenchange",
        this.handleFullscreenChange
      );
      document.addEventListener(
        "mozfullscreenchange",
        this.handleFullscreenChange
      );
      document.addEventListener(
        "MSFullscreenChange",
        this.handleFullscreenChange
      );

      // 绑定其他事件
      window.addEventListener("beforeunload", this.handleBeforeUnload);
      // window.addEventListener(
      //   "visibilitychange",
      //   this.handleVisibilityChange
      // );
      document.addEventListener("keydown", this.blockShortcuts);
      // 窗口焦点变化
      window.addEventListener("focus", this.handleVisibilityChange);
      window.addEventListener("blur", this.handleVisibilityChange);
    },
    // 移除事件监听
    removeFullscreenListeners() {
      document.removeEventListener(
        "fullscreenchange",
        this.handleFullscreenChange
      );
      document.removeEventListener(
        "webkitfullscreenchange",
        this.handleFullscreenChange
      );
      document.removeEventListener(
        "mozfullscreenchange",
        this.handleFullscreenChange
      );
      document.removeEventListener(
        "MSFullscreenChange",
        this.handleFullscreenChange
      );
      window.removeEventListener("keydown", this.handleKeyDown);
      window.removeEventListener("focus", this.handleVisibilityChange);
      window.removeEventListener("blur", this.handleVisibilityChange);
      // window.removeEventListener("visibilitychange", this.handleVisibilityChange);
    },
    // 处理全屏状态变化
    handleFullscreenChange() {
      let _this = this;
      _this.isFullscreen = !!(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement
      );

      // 如果考试进行中且意外退出全屏，立即重新进入
      if (_this.examStarted && !_this.isFullscreen) {
      }
    },
    // 进入全屏
    enterFullscreen() {
      const el = this.$refs.fullscreenContainer;
      const requestMethod =
        el.requestFullscreen ||
        el.webkitRequestFullscreen ||
        el.mozRequestFullScreen ||
        el.msRequestFullscreen;
      if (requestMethod) {
        requestMethod.call(el).catch(err => {
          console.error("全屏失败:", err);
        });
      }
    },
    // 退出全屏
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        /* Firefox */
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        /* IE/Edge */
        document.msExitFullscreen();
      }
    },
    handleBeforeUnload(e) {
      e.preventDefault();
      e.returnValue = "";
      return "";
    },
    poupConfirm() {
      this.isModalVisible = false;
      // this.enterFullscreen();
      if (this.illegalOperateTimer) {
        clearInterval(this.illegalOperateTimer); // 清除定时器
      }
    },
    handleVisibilityChange() {
      let _this = this;
      // console.log('hidden',document.hidden)
      _this.isPageActive = document.hasFocus();
      if (!_this.isPageActive && !document.hidden) {
        _this.illegalOperateCount += 1;
        _this.countDown = 20;
        if (this.illegalOperateTimer) {
          clearInterval(this.illegalOperateTimer);
        }
        // console.log('illegalOperateCount', this.illegalOperateCount);
        if (_this.illegalOperateCount > 2) {
          this.poupContent = `已离开${_this.illegalOperateCount}次，即将自动交卷!`;
          this.isModalVisible = true;
          this.poupConfirmShow = false;
          setTimeout(function() {
            _this.stopText();
            // console.log('次数到了,强制交卷')
          }, 3000);
          return;
        } else {
          this.poupContent = `已离开${_this.illegalOperateCount}次，超过2次将自动交卷!`;
          this.isModalVisible = true;
          this.poupConfirmShow = true;
        }

        _this.illegalOperateTimer = setInterval(function() {
          _this.countDown--;
          // if (_this.countDown === 10) {
          //   _this.illegalOperateCount += 1
          // }
          if (_this.countDown === 0) {
            _this.stopText();
            // console.log('倒计时结束,强制交卷')
            clearInterval(_this.illegalOperateTimer); // 清除定时器
          }
        }, 1000);
      }
    },
    blockShortcuts(e) {
      // 阻止F11、ESC、Ctrl+R等
      if (["Escape", "r"].includes(e.key) || (e.ctrlKey && e.key === "r")) {
        e.preventDefault();
      }
    },
    // 获取考试详情
    getExaminationDetail() {
      let _this = this;
      let parmas = {
        examinationId: _this.examId
      };
      _this.$api.text.getExaminationDetail(parmas).then(res => {
        if (res.code == 200) {
          _this.examination = res.data;
          _this.convertMinutesToHHMMSS(_this.examination.minute);
        }
      });
    },
    // 查询考试页面考生信息
    selectUser() {
      this.$api.text.selectUserMessage().then(response => {
        this.userName = response.data.name;
        // this.examRegistrationNumber = response.data.examRegistrationNumber;
        this.identityCard = response.data.cardNum;
        this.photograph = response.data.headUrl;
      });
    },
    // 选中样式
    handle(item, key) {
      this.currentActive = key;
    },
    // 时间补0
    pad(value) {
      return value.toString().padStart(2, "0");
    },
    // 选项改变的时候记录答案
    handleChange(data) {
      // 单选 多选 判断 主观
      const objChoiceOne = this.subjectList.find(
        item => item.subjectId == data.dataId
      );
      if (data.answer !== null && data.answer.length > 0) {
        objChoiceOne.isOk = true;
        objChoiceOne.currentAnswer = data.answer;
        this.isAnswer = this.subjectList.filter(item => item.isOk).length;
        let params = {
          recordId: this.recordId.toString(),
          subjectId: data.dataId.toString(),
          answer: Array.isArray(data.answer)
            ? data.answer.toString()
            : data.answer,
          type: "examination"
        };

        this.$api.text.answerProcess(params).then(res => {
          if (res.code != 200) {
            this.$message({
              message: "出错了!请联系监考人员",
              type: "warning"
            });
          }
        });
      }
    },
    //不定项选择题
    handleChoiceChange(subjectId, data) {
      const bdx = this.subjectList.find(item => item.subjectId == subjectId);
      let bsxobj = bdx.indefiniteSubjectsList.find(
        item => item.id == data.dataSonId
      );
      if (data.answer !== null && data.answer.length > 0) {
        this.$set(bsxobj, "isOk", true);
        this.$set(bsxobj, "currentAnswer", data.answer);
        let indefiniteSubjectAnswer = bdx.indefiniteSubjectsList.filter(
          item => item.isOk
        ).length;
        if (indefiniteSubjectAnswer == bdx.indefiniteSubjectsList.length) {
          this.subjectList.forEach(item => {
            if (item.subjectId == subjectId) {
              item.isOk = true;
            }
          });
          this.isAnswer = this.subjectList.filter(item => item.isOk).length;
        }

        let params = {
          recordId: this.recordId.toString(),
          subjectId: data.dataId.toString(),
          subjectSonId: data.dataSonId.toString(),
          answer: Array.isArray(data.answer)
            ? data.answer.toString()
            : data.answer,
          type: "examination"
        };
        this.$api.text.answerProcess(params).then(res => {
          if (res.code != 200) {
            this.$message({
              message: "出错了!请联系监考人员",
              type: "warning"
            });
          }
        });
      }
    },
    //分数分配题型
    handleScoreDistributeChange(subjectId, data, sonSubjectId) {
      const scoreDist = this.subjectList.find(
        item => item.subjectId == subjectId
      );
      let scoreObj = scoreDist.scoreDistributeSubjectList.find(
        item => item.id == sonSubjectId
      );
      this.$set(scoreObj, "isOk", true);
      const totalScore = scoreDist.scoreDistributeSubjectList.reduce(
        (sum, item) => sum + (item.currentAnswer ? item.currentAnswer : 0),
        0
      );
      let scoreSubjectAnswer = scoreDist.scoreDistributeSubjectList.filter(
        item => item.isOk
      ).length;
      if (scoreSubjectAnswer == scoreDist.scoreDistributeSubjectList.length) {
        this.subjectList.forEach(item => {
          if (item.subjectId == subjectId) {
            item.isOk = true;
          }
        });
        this.isAnswer = this.subjectList.filter(item => item.isOk).length;
      }
      if (totalScore > 3) {
        this.$message({
          message: "总分已超出!请重新填写",
          type: "error"
        });
        scoreDist.scoreDistributeSubjectList.forEach(item => {
          if (item.id == sonSubjectId) {
            item.currentAnswer = 0;
          }
        });
        this.$forceUpdate();
      }
      let sonSubject = scoreDist.scoreDistributeSubjectList.find(
        item => item.id == sonSubjectId
      );
      let params = {
        recordId: this.recordId.toString(),
        subjectId: subjectId,
        subjectSonId: sonSubjectId,
        answer: sonSubject.currentAnswer,
        type: "examination"
      };
      this.$api.text.answerProcess(params).then(res => {
        if (res.code != 200) {
          this.$message({
            message: "出错了!请联系监考人员",
            type: "warning"
          });
        }
      });
    },
    // 强制提交
    stopText() {
      this.$message({
        message: "考试已结束",
        type: "warning"
      });
      let parmas = {
        recordId: this.recordId
      };
      this.removeFullscreenListeners();
      this.$api.text.submitExamination(parmas).then(res => {
        if (res.code == 200) {
          this.$message({
            message: "交卷成功",
            type: "success"
          });
          this.$router.push({
            name: "examResult",
            query: { recordId: this.recordId }
          });
          this.exitFullscreen();
          this.examStarted = false;
        } else {
          this.$message({
            message: "出错了!请联系监考人员",
            type: "warning"
          });
        }
      });
    },
    // 交卷
    submitText() {
      console.log("submitText111");
      const notOk = [];
      this.subjectList.forEach(item => {
        if (!item.isOk) {
          notOk.push(item);
        }
      });
      console.log("remainingMinutes", this.remainingMinutes);
      console.log("hours", this.hours);
      if (notOk.length) {
        if (this.isFullscreen) {
          this.poupContent = "仍有题目未完成，不可提交";
          this.isModalVisible = true;
        } else {
          this.$message({
            message: "仍有题目未完成，不可提交",
            type: "warning"
          });
        }
      } else {
        if (this.hours === 0 && this.remainingMinutes <= 30) {
          let parmas = {
            recordId: this.recordId
          };
          this.$api.text.submitExamination(parmas).then(res => {
            if (res.code == 200) {
              this.$message({
                message: "交卷成功",
                type: "success"
              });
              this.$router.push({
                name: "examResult",
                query: { recordId: this.recordId }
              });
            }
            this.exitFullscreen();
            this.examStarted = false;
          });
        } else {
          if (this.isFullscreen) {
            this.poupContent = "距考试结束30分钟方可交卷";
            this.isModalVisible = true;
          } else {
            this.$message({
              message: "距考试结束30分钟方可交卷",
              type: "warning"
            });
          }
        }
      }
    },
    // 时分秒转换
    convertMinutesToHHMMSS(minutes) {
      this.hours = Math.floor(minutes / 60);
      this.remainingMinutes = minutes % 60;
      this.seconds = Math.floor((minutes * 60) % 60);

      return this.hours + this.remainingMinutes + this.seconds;
    },
    formatSeconds(value) {
      let secondTime = parseInt(value);
      let minuteTime = 0;
      let hoursTime = 0;
      if (secondTime > 60) {
        minuteTime = parseInt(secondTime / 60);
        secondTime = parseInt(secondTime % 60);
        if (minuteTime > 60) {
          hoursTime = parseInt(minuteTime / 60);
          minuteTime = parseInt(minuteTime % 60);
        }
      }
      this.hours = hoursTime;
      this.remainingMinutes = minuteTime;
      this.seconds = secondTime;
      //喀什倒计时
      this.startCountdown();
    },
    // 倒计时
    startCountdown() {
      this.intervalId = setInterval(() => {
        this.updateCountdown();
      }, 1000);
    },
    // 倒计时结束
    stopCountdown() {
      clearInterval(this.intervalId);
    },
    // 更新倒计时
    updateCountdown() {
      if (this.hours > 0 || this.remainingMinutes > 0 || this.seconds > 0) {
        if (this.remainingMinutes === 0 && this.seconds === 0) {
          this.hours--;
          this.remainingMinutes = 59;
          this.seconds = 59;
        } else if (this.seconds === 0) {
          this.remainingMinutes--;
          this.seconds = 59;
        } else {
          this.seconds--;
        }
      } else {
        //增加校验交卷倒计时 getRemainingTime
        let parmas = {
          examinationId: this.examId,
          recordId: this.recordId
        };
        this.$api.text.getRemainingTime(parmas).then(res => {
          console.log("res", res);
          if (res.code == 200) {
            if (res.data.minute > 0) {
              this.stopCountdown();
              this.seconds = res.data.minute * 60;
              this.formatSeconds(this.seconds);
            } else {
              this.stopCountdown();
              if (
                this.hours === 0 &&
                this.remainingMinutes === 0 &&
                this.seconds === 0
              ) {
                this.stopText();
                return "00:00:00";
              }
            }
          } else {
            this.$message({
              message: "出错了!请联系监考人员",
              type: "warning"
            });
          }
        });
      }
    },
    // 上一题
    backTopic() {
      let arr = this.currentActive.split("-");
      let key = arr[0];
      let index = parseInt(arr[1]);
      index--;
      if (index <= -1) {
        const topicmap = [
          "radio",
          "check",
          "istrue",
          "textarea",
          "choiceQuestions",
          "scoreDistributeQuestions",
          "rankingQuestion"
        ];
        let topindex = topicmap.indexOf(key);
        if (topindex == 0) {
          this.$message({
            message: "没有上一题了",
            type: "warning"
          });
          return;
        }
        this.currentActive =
          topicmap[topindex - 1] +
          "-" +
          (this[topicmap[topindex - 1]].length - 1);
      } else {
        this.currentActive = key + "-" + index;
      }
    },
    // 下一题
    nextTopic() {
      let arr = this.currentActive.split("-");
      let key = arr[0];
      let index = parseInt(arr[1]);
      index++;
      if (this[key].length == index || this[key].length < index) {
        const topicmap = [
          "radio",
          "check",
          "istrue",
          "textarea",
          "choiceQuestions",
          "scoreDistributeQuestions",
          "rankingQuestion"
        ];
        let topindex = topicmap.indexOf(key);
        if (topindex == 5) {
          this.$message({
            message: "没有下一题了",
            type: "warning"
          });
          return;
        }
        this.currentActive = topicmap[topindex + 1] + "-" + 0;
      } else {
        this.currentActive = key + "-" + index;
      }
    },
    // 获取题目
    getStartExamination() {
      let _this = this;
      let parmas = {
        examinationId: _this.examId,
        type: 2
      };
      _this.$api.text.getStartExamination(parmas).then(res => {
        if (res.code != 200) {
          this.$message({
            message: res.msg,
            type: "warning"
          });
          let timer = setTimeout(() => {
            this.$router.go(-1);
          }, 1000);

          return;
        }
        res.data.testPaper.subjectItems.forEach(item => {
          if (item.subjectType == 0) {
            this.radioSubjectType++;
          } else if (item.subjectType == 1) {
            this.checkSubjectType++;
          } else if (item.subjectType == 2) {
            this.istrueSubjectType++;
          } else if (item.subjectType == 3) {
            this.textareaSubjectType++;
          } else if (item.subjectType == 4) {
            this.choiceQuestionsSubjectType++;
          } else if (item.subjectType == 5) {
            this.scoreDistributeSubjectType++;
          } else if (item.subjectType == 6) {
            this.rankingQuestionType++;
          }
        });
        if (res.code == 200) {
          _this.subjectList = res.data.testPaper.subjectItems;
          _this.recordId = res.data.recordId;
          _this.subjectList.forEach(function(item) {
            item.isOk = false; //当前是否已做
            item.isActive = false; //当前是否选中
            if (item.subjectType == 0) {
              _this.radio.push(item);
            } else if (item.subjectType == 1) {
              _this.check.push(item);
            } else if (item.subjectType == 2) {
              _this.istrue.push(item);
            } else if (item.subjectType == 3) {
              _this.textarea.push(item);
            } else if (item.subjectType == 4) {
              _this.choiceQuestions.push(item);
            } else if (item.subjectType == 5) {
              _this.scoreDistributeQuestions.push(item);
            } else if (item.subjectType == 6) {
              _this.rankingQuestion.push(item);
            }
          });

          const userAnswer = res.data.userAnswer;
          if (userAnswer instanceof Array && userAnswer.length > 0) {
            userAnswer.forEach(item => {
              const obj = _this.subjectList.find(
                val => val.subjectId === item.subjectId
              );
              if (
                item.subjectSonId &&
                obj.subjectType == 4 &&
                obj.indefiniteSubjectsList
              ) {
                obj.indefiniteSubjectsList.forEach(subItem => {
                  if (subItem.id === item.subjectSonId) {
                    subItem.isOk = true;
                    // 将字符串形式的答案转换为数组
                    subItem.currentAnswer = item.answer
                      .split(",")
                      .map(answer => answer.trim());
                  }
                });
                let indefiniteSubjectAnswer = obj.indefiniteSubjectsList.filter(
                  item => item.isOk
                ).length;
                if (
                  indefiniteSubjectAnswer == obj.indefiniteSubjectsList.length
                ) {
                  obj.isOk = true;
                  ++_this.isAnswer;
                }
              } else if (
                item.subjectSonId &&
                obj.subjectType == 5 &&
                obj.scoreDistributeSubjectList
              ) {
                obj.scoreDistributeSubjectList.forEach(subItem => {
                  if (subItem.id === item.subjectSonId) {
                    subItem.isOk = true;
                    // 将字符串形式的答案转换为数组
                    subItem.currentAnswer = item.answer;
                  }
                  let scoreSubjectAnswer = obj.scoreDistributeSubjectList.filter(
                    item => item.isOk
                  ).length;
                  if (
                    scoreSubjectAnswer == obj.scoreDistributeSubjectList.length
                  ) {
                    obj.isOk = true;
                    _this.isAnswer++;
                  }
                });
              } else {
                // 单选、多选、判断或主观题的处理
                obj.isOk = true;
                // obj.currentAnswer = item.answer;
                if (obj.subjectType === 1) {
                  // 多选题
                  obj.currentAnswer = item.answer
                    .split(",")
                    .map(answer => answer.trim());
                } else {
                  obj.currentAnswer = item.answer;
                }
                _this.isAnswer++;
              }
            });
          }
          this.seconds = res.data.minute * 60;
          _this.formatSeconds(this.seconds);
          // _this.formatSeconds(120);
          this.examStarted = true;
          // this.enterFullscreen();
          // document.getElementById("myButton").click();
        }
      });
    }
  }
};
</script>
<style scoped>
.box {
  padding: 10px;
  height: 100vh;
  width: 100%;
  flex-direction: column;
  display: flex;
  background-color: rgb(239, 243, 247);
}

.top-box {
  left: 10px;
  right: 10px;
  height: 70px;
  color: rgb(255, 255, 255);
  background-color: rgb(64, 112, 179);
}

.box-head-one {
  font-size: 30px;
  /** 试卷题目字体大小 */
  line-height: 70px;
  float: left;
  margin-left: 15px;
}

.box-head-two {
  float: right;
  font-size: 18px;
  /** 考试姓名 准考证号 字体大小 */
}

.box-head-two-name {
  height: 35px;
  line-height: 35px;
  width: 300px;
  color: rgb(255, 255, 255);
}

.box .center-box {
  margin-top: 15px;
  /* width: 100%; */
  align-items: stretch;
  height: 85vh;
}

.options-box {
  /* width: 10%; */
  float: left;
  height: 100%;
  overflow-y: auto;
}

.center-box .options-box {
  width: 15%;
  background: rgb(255, 255, 255);
  overflow-y: auto;
}

.options-box .slide {
  /* width: 100%; */
  height: 24px;
  display: flex;
  justify-content: flex-end;
  margin: 8px 0px;
}

.options-box .slide img {
  width: 24px;
  /* height: 100%; */
  cursor: pointer;
}

.options-box .title {
  /* width: 100%; */
  height: 30px;
  font-weight: bold;
  box-sizing: border-box;
  border-radius: 15px;
  text-align: left;
  padding-left: 10px;
  line-height: 30px;
  color: rgb(0, 0, 0);
  font-family: 思源黑体;
  font-size: 16px;
  /** 单线选择题字体大小 */
}

.options-box .topic-item {
  justify-content: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  /* width: 100%; */
  padding: 10px 17px;
  box-sizing: border-box;
  gap: 10px;
}

.options-box .topic-item div.active {
  background: rgb(64, 112, 179);
  color: rgb(255, 255, 255);
}

.options-box .topic-item div {
  width: 25px;
  height: 25px;
  box-sizing: border-box;
  cursor: pointer;
  background: rgb(242, 249, 255);
  border: 1px solid rgb(64, 112, 179);
  border-radius: 8px;
  color: rgb(0, 0, 0);
  font-family: 思源黑体;
  font-size: 12px;
  /** 题目序号字体大小 */
  text-align: center;
  line-height: 25px;
}

.topic-box {
  float: left;
  width: 68%;
  padding: 26px 29px;
  overflow-y: auto;
  height: 100%;
  background-color: rgb(255, 255, 255);
  margin-left: 15px;
}

.topic-right {
  text-align: center;
  float: right;
  width: 15%;
}

.surplus-time {
  text-align: center;
  justify-content: center;
  margin: 0 auto;
  margin-top: 15px;
  width: 75%;
  /* height: 300px; */
  background-color: rgb(255, 255, 255);
}

.surplus-time-top {
  padding-top: 15px;
  font-size: 18px;
  /** 剩余时间 答题进度 字体大小 */
  font-weight: bold;
}

.surplus-time-color {
  color: red;
  font-family: 思源黑体;
  font-size: 22px;
  /** 剩余时间字体大小 */
}

.surplus-time-line {
  margin-top: 10px;
  border: 1px solid rgb(235, 238, 246);
}

.progress-box {
  width: 100%;
  position: relative;
  margin-right: 100px;
}

.progress-box .bar {
  height: 10px;
  position: absolute;
  background: rgba(124, 132, 139);
  opacity: 0.4;
  border-radius: 1px;
}

.progress-box .slider {
  height: 10px;
  background: rgb(64, 112, 179);
  top: 0;
}

.progress-box .bar-info {
  color: red;
  font-family: 思源黑体;
  font-size: 22px;
  /** 答题进度字体大小 */
  text-align: center;
}

.topic-padding {
  padding: 15px;
}

.topic-up {
  margin: 0 auto;
  width: 110px;
  height: 50px;
  line-height: 50px;
  background: rgb(64, 112, 179);
  color: rgb(255, 255, 255);
  border-radius: 15px;
  font-size: 18px;
  cursor: pointer;
}

.topic-below {
  margin: 0 auto;
  width: 110px;
  height: 50px;
  line-height: 50px;
  background: rgb(64, 112, 179);
  color: rgb(255, 255, 255);
  border-radius: 15px;
  font-size: 18px;
  margin-top: 15px;
  cursor: pointer;
}

.topic-right .submit-buuton {
  margin-top: 25px;
}

.score-particulars {
  font-weight: bold;
}

.custom-modal {
  padding-top: 100px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  /* align-items: center; */
  align-items: flex-start;
  z-index: 9999; /* 确保在最上层 */
}

.modal-header {
  display: flex;
  color: red;
  font-size: 20px;
  justify-content: center;
}

.modal-content {
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  max-width: 80%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.modal-footer {
  text-align: center;
  border: none;
  padding-bottom: 20pxpx;
  padding-top: 0;
}

.btn {
  width: 100px;
  height: 34px;
  padding: 0;
  line-height: 32px;
}

.btn-gray {
  background: #f2f2f2;
  border: 1px solid #f2f2f2;
  color: #666666;
}

/* .logo-text-ui {
  font-size: calc(100vw * 24 / 1920);
}
@media screen and (min-width: 1000px) and (max-width: 1200px) {
  .logo-text-ui {
    font-size: 17px;
    top: 24% !important;
    letter-spacing: 2px;
  }
}
@media screen and (min-width: 1280px) and (max-width: 1360px) {
  .logo-text-ui {
    font-size: 23px;
    top: 24% !important;
    letter-spacing: 2px;
  }
}
@media screen and (min-width: 1360px) and (max-width: 1366px) {
  .logo-text-ui {
    font-size: 24px;
    top: 18% !important;
    letter-spacing: 2px;
  }
}
@media screen and (min-width: 1366px) and (max-width: 1400px) {
  .logo-text-ui {
    font-size: 24px;
    top: 18% !important;
    letter-spacing: 2px;
  }
}
@media screen and (min-width: 1400px) and (max-width: 1440px) {
  .logo-text-ui {
    font-size: 26px;
    top: 24% !important;
    letter-spacing: 2px;
  }
}

@media screen and (min-width: 1440px) and (max-width: 1600px) {
  .logo-text-ui {
    font-size: 26px;
    top: 10% !important;
    letter-spacing: 1px;
  }
}
@media screen and (min-width: 1600px) and (max-width: 1680px) {
  .logo-text-ui {
    font-size: 29px;
    top: 15% !important;
    letter-spacing: 2px;
  }
}
@media screen and (min-width: 1680px) and (max-width: 1920px) {
  .logo-text-ui {
    font-size: 32px;
    top: 7% !important;
    letter-spacing: 1px;
  }
}

@media screen and (min-width: 1920px) {
  .logo-text-ui {
    font-size: 36px;
    top: 10% !important;
    letter-spacing: 2px;
  }
} */
</style>



// WEBPACK FOOTER //
// src/view/text/text1.vue